/**
 * Extracts the response data from the response object, either as JSON or text
 * @param {Response} response
 */
const getResponseData = async <R>(response: Response): Promise<R> => {
  return await response
    .clone()
    .json()
    .catch(async () => await response.text());
};

export default getResponseData;
